import Grid from "@material-ui/core/Grid";
import React from "react";
import Photo from "./Photo";

const PhotoList = ({photos, active, activePhotoIndex}) => {
  return (
    <Grid container spacing={0.5}>
      {photos.map(
        (photo, index) => (
          <Grid item key={index}>
            <Photo
              photo={photo}
              active={photo.index === active}
              activePhotoIndex={activePhotoIndex}
            />
          </Grid>
        )
      )}
    </Grid>
  );
};

export default PhotoList;
